'use client';

import React from 'react';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import ConsumerSearchBarLegacy from './ConsumerSearchBarLegacy';
import ConsumerSearchBarNext from './consumer-search-modal-next';

const ConsumerSearchBar = props => {
  const isBrowser = useIsBrowser();
  const postHogFlag = usePostHogFeatureFlag('consumerSearchBarNext');

  if (!isBrowser) {
    return <div />;
  }

  const useNextVersion = postHogFlag === 'test' || isNewConsumerApp;

  return useNextVersion ? (
    <ConsumerSearchBarNext {...props} />
  ) : (
    <ConsumerSearchBarLegacy {...props} />
  );
};

export default ConsumerSearchBar;
